import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

// Import images
import breadcrumbBg from '../../assets/img/bg/breadcrumb-bg.png';
import cloudIcon from '../../assets/img/icons/cloud.png';
import ballonIcon from '../../assets/img/icons/ballon-sclation.png';
import koreaImg from '../../assets/img/korea.png';
import keralaImg from '../../assets/img/kerala.jpg';
import seoulImg from '../../assets/img/SEOUL.png';
import maduraiImg from '../../assets/img/MADHURAI.png';
import jejuImg from '../../assets/img/JEJU.png';
import karnatakaImg from '../../assets/img/kRNtK.png';
import busanImg from '../../assets/img/BUSAN.png';

// Package Data with 2026 Market-Based Pricing
const packageData = {
  "south-india-korea": {
    id: "south-india-korea",
    title: "South India & Korea Cultural Fusion",
    duration: "10 Days",
    adultPrice: 185000,
    childPrice: 155000,
    originalAdultPrice: 225000,
    originalChildPrice: 190000,
    image: koreaImg,
    description: "Blend of South India heritage & Korea modern culture...",
    shortDescription: "Experience the perfect harmony of ancient traditions and cutting-edge technology",
    region: "international",
    highlights: [
      "Stay in traditional Kerala houseboat",
      "Visit Gyeongbokgung Palace in Seoul",
      "Authentic Korean BBQ cooking class",
      "Ayurvedic massage experience in Kerala",
      "K-pop street and entertainment districts",
      "Tea plantation tour in Munnar hills"
    ],
    tripInfo: {
      transportation: "Flight, AC Coach, Metro",
      departure: "Delhi, Mumbai, Bangalore",
      groupSize: "2-20 Travelers",
      accommodation: "4 Star Hotels & Traditional Stays",
      bestSeason: "Oct - Mar (Pleasant Weather)",
      minAge: "8 Years",
      meals: "Breakfast & Special Dinners",
      tourType: "Cultural, Food, Photography"
    }
  },
  "kerala-retreat": {
    id: "kerala-retreat",
    title: "Kerala Backwaters & Ayurvedic Retreat",
    duration: "7 Days",
    adultPrice: 58000,
    childPrice: 43000,
    originalAdultPrice: 68000,
    originalChildPrice: 52000,
    image: keralaImg,
    description: "Experience Kerala backwaters & wellness retreat...",
    shortDescription: "Rejuvenate your senses in God's Own Country",
    region: "domestic",
    highlights: [
      "Houseboat cruise in Alleppey backwaters",
      "Authentic Ayurvedic massage",
      "Tea plantation visit in Munnar",
      "Kathakali dance performance",
      "Wildlife spotting in Periyar",
      "Cooking class with local family"
    ],
    tripInfo: {
      transportation: "AC Coach, Houseboat",
      departure: "Cochin, Trivandrum",
      groupSize: "2-15 Travelers",
      accommodation: "3-4 Star Hotels & Houseboats",
      bestSeason: "Sep - Mar (Pleasant Weather)",
      minAge: "5 Years",
      meals: "All Meals Included",
      tourType: "Wellness, Nature, Cultural"
    }
  },
  "seoul-discovery": {
    id: "seoul-discovery",
    title: "Seoul K-Pop & Palace Discovery",
    duration: "5 Days",
    adultPrice: 125000,
    childPrice: 105000,
    originalAdultPrice: 145000,
    originalChildPrice: 120000,
    image: seoulImg,
    description: "Explore Seoul palaces, K-pop districts & culture.",
    shortDescription: "Dive into the heart of Korean pop culture and history",
    region: "international",
    highlights: [
      "Gyeongbokgung Palace visit with changing of guards",
      "K-pop entertainment district tour",
      "N Seoul Tower with panoramic views",
      "Traditional Korean cooking class",
      "Myeongdong shopping street",
      "DMZ tour option available"
    ],
    tripInfo: {
      transportation: "Flight, Metro, Coach",
      departure: "Delhi, Mumbai, Bangalore",
      groupSize: "2-15 Travelers",
      accommodation: "4 Star Hotels",
      bestSeason: "Apr - Jun, Sep - Nov",
      minAge: "10 Years",
      meals: "Breakfast & 2 Special Dinners",
      tourType: "Cultural, Entertainment, Food"
    }
  },
  "karnataka-heritage": {
    id: "karnataka-heritage",
    title: "Karnataka Heritage & Coffee Plantations",
    duration: "5 Days",
    adultPrice: 35000,
    childPrice: 26000,
    originalAdultPrice: 39000,
    originalChildPrice: 30000,
    image: karnatakaImg,
    description: "Heritage temples & coffee estate stays.",
    shortDescription: "Explore majestic ruins and aromatic coffee plantations",
    region: "domestic",
    highlights: [
      "Hampi UNESCO heritage site exploration",
      "Coffee plantation stay and tour",
      "Mysore Palace visit",
      "Traditional Karnataka cuisine experience",
      "Brindavan Gardens light show",
      "Silk weaving center visit"
    ],
    tripInfo: {
      transportation: "AC Coach, Private Vehicle",
      departure: "Bangalore, Mysore",
      groupSize: "2-12 Travelers",
      accommodation: "Heritage Hotels & Plantation Stays",
      bestSeason: "Oct - Mar",
      minAge: "5 Years",
      meals: "Breakfast & Select Dinners",
      tourType: "Heritage, Nature, Cultural"
    }
  },
  "tamil-nadu-temple": {
    id: "tamil-nadu-temple",
    title: "Tamil Nadu Temple & Cultural Trail",
    duration: "6 Days",
    adultPrice: 44000,
    childPrice: 33000,
    originalAdultPrice: 52000,
    originalChildPrice: 40000,
    image: maduraiImg,
    description: "Explore magnificent Dravidian temples and rich culture",
    shortDescription: "Journey through the land of ancient temples",
    region: "domestic",
    highlights: [
      "Meenakshi Temple visit in Madurai",
      "Brihadeeswarar Temple in Thanjavur",
      "Traditional Bharatanatyam performance",
      "Chettinad heritage tour",
      "South Indian cooking class",
      "Silk saree weaving demonstration"
    ],
    tripInfo: {
      transportation: "AC Coach, Private Vehicle",
      departure: "Chennai, Madurai",
      groupSize: "2-15 Travelers",
      accommodation: "3-4 Star & Heritage Hotels",
      bestSeason: "Nov - Feb",
      minAge: "5 Years",
      meals: "Breakfast & Select Dinners",
      tourType: "Temple, Cultural, Food"
    }
  },
  "jeju-island": {
    id: "jeju-island",
    title: "Jeju Island Explorer",
    duration: "5 Days",
    adultPrice: 145000,
    childPrice: 120000,
    originalAdultPrice: 160000,
    originalChildPrice: 135000,
    image: jejuImg,
    description: "Discover volcanic landscapes and natural wonders",
    shortDescription: "Korea's volcanic paradise with stunning natural beauty",
    region: "international",
    highlights: [
      "Hallasan Mountain hiking",
      "Manjanggul Lava Tube exploration",
      "Seongsan Ilchulbong sunrise peak",
      "Jeju Haenyeo (female divers) experience",
      "O'sulloc green tea plantation",
      "Loveland & theme parks"
    ],
    tripInfo: {
      transportation: "Flight, Rental Vehicle",
      departure: "Seoul, Busan",
      groupSize: "2-12 Travelers",
      accommodation: "4 Star Resorts & Hotels",
      bestSeason: "Apr - Jun, Sep - Nov",
      minAge: "8 Years",
      meals: "Breakfast Included",
      tourType: "Nature, Adventure, Cultural"
    }
  },
  "busan-coastal": {
    id: "busan-coastal",
    title: "Busan Coastal & Food Tour",
    duration: "4 Days",
    adultPrice: 110000,
    childPrice: 92000,
    originalAdultPrice: 125000,
    originalChildPrice: 105000,
    image: busanImg,
    description: "Coastal beauty and fresh seafood delights",
    shortDescription: "Experience Korea's vibrant coastal city",
    region: "international",
    highlights: [
      "Haeundae Beach relaxation",
      "Gamcheon Culture Village tour",
      "Jagalchi Fish Market experience",
      "Haedong Yonggungsa Temple",
      "Fresh seafood dinner",
      "Night view from Busan Tower"
    ],
    tripInfo: {
      transportation: "Flight, Metro, Coach",
      departure: "Seoul, Incheon",
      groupSize: "2-15 Travelers",
      accommodation: "4 Star Beachfront Hotels",
      bestSeason: "Apr - Jun, Sep - Nov",
      minAge: "5 Years",
      meals: "Breakfast & 1 Seafood Dinner",
      tourType: "Coastal, Food, Cultural"
    }
  }
};

const BookDestination = () => {
    const { packageId } = useParams();
    
    const [currentPackage, setCurrentPackage] = useState(null);
    const [similarTours, setSimilarTours] = useState([]);
    
    useEffect(() => {
        // Set current package based on URL
        if (packageId && packageData[packageId]) {
            setCurrentPackage(packageData[packageId]);
        } else {
            // Default to first package if invalid ID
            setCurrentPackage(packageData["south-india-korea"]);
        }

        // Set minimum date for departure date
        const today = new Date();
        today.setDate(today.getDate() + 7);
        const minDate = today.toISOString().split("T")[0];
        const departureInput = document.querySelector("#departure");
        if (departureInput) {
            departureInput.min = minDate;
        }
    }, [packageId]);

    useEffect(() => {
        // Generate similar tours based on current package region
        if (currentPackage) {
            const allTours = Object.values(packageData);
            const filtered = allTours
                .filter(pkg => pkg.id !== currentPackage.id)
                .filter(pkg => pkg.region === currentPackage.region)
                .slice(0, 3)
                .map((pkg, index) => ({
                    id: pkg.id,
                    image: pkg.image,
                    location: pkg.region === 'international' ? 
                        pkg.title.split(' ').slice(-2).join(' ') : 
                        pkg.title.split(' ').slice(0,2).join(' '),
                    title: pkg.title,
                    duration: pkg.duration,
                    originalPrice: `₹${pkg.originalAdultPrice?.toLocaleString('en-IN') || pkg.adultPrice.toLocaleString('en-IN')}`,
                    discountedPrice: `₹${pkg.adultPrice.toLocaleString('en-IN')}`
                }));
            
            // Add some from other regions if not enough
            if (filtered.length < 3) {
                const otherRegionTours = allTours
                    .filter(pkg => pkg.id !== currentPackage.id)
                    .slice(0, 3 - filtered.length)
                    .map((pkg, index) => ({
                        id: pkg.id,
                        image: pkg.image,
                        location: pkg.region === 'international' ? 
                            pkg.title.split(' ').slice(-2).join(' ') : 
                            pkg.title.split(' ').slice(0,2).join(' '),
                        title: pkg.title,
                        duration: pkg.duration,
                        originalPrice: `₹${pkg.originalAdultPrice?.toLocaleString('en-IN') || pkg.adultPrice.toLocaleString('en-IN')}`,
                        discountedPrice: `₹${pkg.adultPrice.toLocaleString('en-IN')}`
                    }));
                setSimilarTours([...filtered, ...otherRegionTours]);
            } else {
                setSimilarTours(filtered);
            }
        }
    }, [currentPackage]);

    const scrollToBooking = () => {
        const bookingSection = document.getElementById("booking");
        if (bookingSection) {
            bookingSection.scrollIntoView({
                behavior: "smooth",
            });
        }
    };

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        departure: "",
        adults: "2",
        children: "0",
        message: ""
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const txnid = "TXN" + Date.now();

            const response = await fetch("http://localhost:5000/api/payment/create", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    txnid,
                    firstname: formData.name,
                    email: formData.email,
                    phone: formData.phone,
                    adults: parseInt(formData.adults),
                    children: parseInt(formData.children),
                    packageId: currentPackage.id,
                    adultPrice: currentPackage.adultPrice,
                    childPrice: currentPackage.childPrice,
                    packageTitle: currentPackage.title
                }),
            });

            const data = await response.json();

            if (response.ok && data.payment_url) {
                window.location.href = data.payment_url;
            } else {
                alert(data.error_desc || "Payment initialization failed.");
            }
        } catch (error) {
            console.error("Payment Error:", error);
            alert("Server connection failed.");
        }
    };

    if (!currentPackage) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh' 
            }}>
                <h2>Loading package details...</h2>
            </div>
        );
    }

    return (
        <div className="book-destination-page">
            {/* Breadcrumb Section */}
            <section
                className="vs-breadcrumb"
                style={{
                    backgroundImage: `url(${breadcrumbBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                    overflow: 'hidden',
                    padding: '100px 0'
                }}
            >
                <img
                    src={cloudIcon}
                    alt="vs-breadcrumb-icon"
                    className="vs-breadcrumb-icon-1"
                    style={{
                        position: 'absolute',
                        top: '20%',
                        left: '10%',
                        zIndex: 1,
                        animation: 'float 6s ease-in-out infinite'
                    }}
                />
                <img
                    src={ballonIcon}
                    alt="vs-breadcrumb-icon"
                    className="vs-breadcrumb-icon-2"
                    style={{
                        position: 'absolute',
                        bottom: '20%',
                        right: '10%',
                        zIndex: 1,
                        animation: 'float 6s ease-in-out infinite'
                    }}
                />
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title" style={{
                                    color: '#fff',
                                    fontSize: '48px',
                                    fontWeight: '700',
                                    marginBottom: '20px',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                                }}>
                                    {currentPackage.title}
                                </h1>
                            </div>
                            <div className="breadcrumb-menu">
                                <ul className="custom-ul" style={{
                                    listStyle: 'none',
                                    padding: 0,
                                    margin: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px',
                                    color: '#fff'
                                }}>
                                    <li>
                                        <Link
                                            to="/"
                                            style={{
                                                color: '#fff',
                                                textDecoration: 'none',
                                                transition: 'color 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.color = '#f7921f';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.color = '#fff';
                                            }}
                                        >
                                            Home
                                        </Link>
                                    </li>
                                    <li style={{ color: '#f7921f' }}>→</li>
                                    <li style={{ color: '#f7921f' }}>Trips details</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Destination Details Section */}
            <section className="vs-destination-details space bg-theme-07">
                <div className="container">
                    <div className="row gx-3 gx-xl-5 gy-5">
                        <div className="col-lg-8">
                            <div className="vs-destination-single">
                                <div className="row align-items-center gy-3 mb-4">
                                    <div className="col-8 col-sm-10">
                                        <h2 className="destination-single-title">
                                            {currentPackage.title}
                                        </h2>
                                        <div className="rating-badge">
                                            <span className="stars">★★★★★</span>
                                            <span className="review-count">(128 Reviews)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 col-sm-2 d-flex justify-content-end">
                                        <div className="destination-single-meta">
                                            <h3>{currentPackage.duration.split(' ')[0]}</h3>
                                            <span>{currentPackage.duration.split(' ')[1]}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="destination-single-info">
                                    <figure className="destination-single-img d-block" style={{ position: 'relative' }}>
                                        <img
                                            src={currentPackage.image}
                                            alt={currentPackage.title}
                                            style={{ width: '100%', borderRadius: '15px' }}
                                        />
                                        <div className="image-badge">
                                            <span className="trending-badge">🔥 Trending</span>
                                            <span className="family-badge">
                                                {currentPackage.region === 'international' ? '🌏 International' : '🇮🇳 Domestic'}
                                            </span>
                                        </div>
                                    </figure>
                                    <div className="destination-single-px">
                                        <div className="trip-info">
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-plane"></i>
                                                    <span>Transportation</span>
                                                </div>
                                                <h6 className="info-title">{currentPackage.tripInfo.transportation}</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-location-dot"></i>
                                                    <span>Departure From</span>
                                                </div>
                                                <h6 className="info-title">{currentPackage.tripInfo.departure}</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-users"></i>
                                                    <span>Group Size</span>
                                                </div>
                                                <h6 className="info-title">{currentPackage.tripInfo.groupSize}</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-hotel"></i>
                                                    <span>Accommodation</span>
                                                </div>
                                                <h6 className="info-title">{currentPackage.tripInfo.accommodation}</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-calendar"></i>
                                                    <span>Best Season</span>
                                                </div>
                                                <h6 className="info-title">{currentPackage.tripInfo.bestSeason}</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-user"></i>
                                                    <span>Minimum Age</span>
                                                </div>
                                                <h6 className="info-title">{currentPackage.tripInfo.minAge}</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-utensils"></i>
                                                    <span>Meals</span>
                                                </div>
                                                <h6 className="info-title">{currentPackage.tripInfo.meals}</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-camera"></i>
                                                    <span>Tour Type</span>
                                                </div>
                                                <h6 className="info-title">{currentPackage.tripInfo.tourType}</h6>
                                            </div>
                                        </div>

                                        {/* Overview Section */}
                                        <div id="current" className="destination-overview tab-content">
                                            <h4 className="title">Tour Overview</h4>
                                            <p>
                                                {currentPackage.shortDescription}
                                            </p>
                                            <p>
                                                {currentPackage.description}
                                            </p>

                                            <div className="highlights-section">
                                                <h5>🌟 Tour Highlights</h5>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <ul className="custom-ul">
                                                            {currentPackage.highlights.slice(0, Math.ceil(currentPackage.highlights.length/2)).map((highlight, index) => (
                                                                <li key={index}>
                                                                    <i className="fa-solid fa-check-circle" style={{color: '#f7921f', marginRight: '10px'}}></i>
                                                                    {highlight}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <ul className="custom-ul">
                                                            {currentPackage.highlights.slice(Math.ceil(currentPackage.highlights.length/2)).map((highlight, index) => (
                                                                <li key={index}>
                                                                    <i className="fa-solid fa-check-circle" style={{color: '#f7921f', marginRight: '10px'}}></i>
                                                                    {highlight}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Booking Form Section */}
                                        <div id="booking" className="destination-request tab-content">
                                            <h4 className="title">Book This Tour</h4>
                                            <h5 className="sub-title">
                                                Ready for your adventure? Fill the form below and we'll
                                                contact you within 24 hours.
                                            </h5>
                                            <p className="short-info">
                                                <strong>Tour Package:</strong> {currentPackage.title} ({currentPackage.duration})
                                            </p>
                                            <div className="row">
                                                <div className="col-12">
                                                    <form onSubmit={handleSubmit} className="form-style2">
                                                        <div className="row">
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="name">
                                                                    Your Name <span>*</span>
                                                                </label>
                                                                <input
                                                                    id="name"
                                                                    name="name"
                                                                    value={formData.name}
                                                                    onChange={handleChange}
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Full Name"
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="email">
                                                                    Your Email <span>*</span>
                                                                </label>
                                                                <input
                                                                    id="email"
                                                                    name="email"
                                                                    value={formData.email}
                                                                    onChange={handleChange}
                                                                    type="email"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Email"
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="phone">
                                                                    Contact Number <span>*</span>
                                                                </label>
                                                                <input
                                                                    id="phone"
                                                                    name="phone"
                                                                    value={formData.phone}
                                                                    onChange={handleChange}
                                                                    type="tel"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Mobile Number"
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="departure">
                                                                    Preferred Departure Date
                                                                </label>
                                                                <input
                                                                    id="departure"
                                                                    name="departure"
                                                                    value={formData.departure}
                                                                    onChange={handleChange}
                                                                    type="date"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="adults">Number of Adults</label>
                                                                <select
                                                                    id="adults"
                                                                    name="adults"
                                                                    value={formData.adults}
                                                                    onChange={handleChange}
                                                                    className="form-control"
                                                                >
                                                                    <option value="1">1 Adult</option>
                                                                    <option value="2">2 Adults</option>
                                                                    <option value="3">3 Adults</option>
                                                                    <option value="4">4 Adults</option>
                                                                    <option value="5">5+ Adults</option>
                                                                </select>
                                                            </div>
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="children">Number of Children</label>
                                                                <select
                                                                    id="children"
                                                                    name="children"
                                                                    value={formData.children}
                                                                    onChange={handleChange}
                                                                    className="form-control"
                                                                >
                                                                    <option value="0">No Children</option>
                                                                    <option value="1">1 Child</option>
                                                                    <option value="2">2 Children</option>
                                                                    <option value="3">3 Children</option>
                                                                </select>
                                                            </div>
                                                            <div className="col-12 form-group">
                                                                <label htmlFor="message">
                                                                    Special Requirements
                                                                </label>
                                                                <textarea
                                                                    id="message"
                                                                    name="message"
                                                                    value={formData.message}
                                                                    onChange={handleChange}
                                                                    className="form-control"
                                                                    placeholder="Any dietary restrictions, special occasions, or specific requirements..."
                                                                    rows="3"
                                                                ></textarea>
                                                            </div>
                                                            <div className="col-12 form-group mb-0">
                                                                <button
                                                                    className="vs-btn style9 w-100"
                                                                    type="submit"
                                                                    style={{
                                                                        background: '#f7921f',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        padding: '15px 30px',
                                                                        borderRadius: '5px',
                                                                        fontSize: '18px',
                                                                        fontWeight: '600',
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.3s ease'
                                                                    }}
                                                                    onMouseEnter={(e) => {
                                                                        e.target.style.background = '#e6831a';
                                                                        e.target.style.transform = 'translateY(-2px)';
                                                                    }}
                                                                    onMouseLeave={(e) => {
                                                                        e.target.style.background = '#f7921f';
                                                                        e.target.style.transform = 'translateY(0)';
                                                                    }}
                                                                >
                                                                    <i className="fa-solid fa-paper-plane me-2"></i>
                                                                    Send Booking Request
                                                                </button>
                                                                <p className="text-center mt-3">
                                                                    <small>
                                                                        🔒 Your information is secure and will
                                                                        never be shared with third parties
                                                                    </small>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div className="col-lg-4">
                            <div className="sidebar-area tours-sidebar">
                                <div
                                    className="widget widget_trip-Availability accordion"
                                    id="accordionTripAvailability"
                                >
                                    <div className="accordion-item">
                                        <h6 className="accordion-header">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne_1"
                                                aria-expanded="true"
                                                style={{
                                                    background: '#f8f9fa',
                                                    color: '#333',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                💰 Package Pricing
                                            </button>
                                        </h6>
                                        <div
                                            id="collapseOne_1"
                                            className="accordion-collapse collapse show"
                                        >
                                            <div className="accordion-body">
                                                <div className="header">
                                                    <span className="offer" style={{
                                                        background: '#f7921f',
                                                        color: 'white',
                                                        padding: '5px 10px',
                                                        borderRadius: '3px',
                                                        fontSize: '14px',
                                                        fontWeight: '600'
                                                    }}>Limited Time Offer</span>
                                                    <div className="package-wrapper d-flex justify-content-between gap-2 mt-3">
                                                        <div className="adult-price">
                                                            <div className="title">
                                                                from
                                                                {currentPackage.originalAdultPrice && (
                                                                    <del style={{marginLeft: '5px', color: '#999'}}>
                                                                        ₹{currentPackage.originalAdultPrice.toLocaleString('en-IN')}
                                                                    </del>
                                                                )}
                                                            </div>
                                                            <h5 className="price" style={{color: '#f7921f', fontSize: '24px', fontWeight: '700'}}>
                                                                ₹{currentPackage.adultPrice.toLocaleString('en-IN')}
                                                                <span style={{fontSize: '14px', fontWeight: 'normal', color: '#666'}}>/Adult</span>
                                                            </h5>
                                                        </div>
                                                        <div className="child-price">
                                                            <div className="title">
                                                                from
                                                                {currentPackage.originalChildPrice && (
                                                                    <del style={{marginLeft: '5px', color: '#999'}}>
                                                                        ₹{currentPackage.originalChildPrice.toLocaleString('en-IN')}
                                                                    </del>
                                                                )}
                                                            </div>
                                                            <h5 className="price" style={{color: '#f7921f', fontSize: '24px', fontWeight: '700'}}>
                                                                ₹{currentPackage.childPrice.toLocaleString('en-IN')}
                                                                <span style={{fontSize: '14px', fontWeight: 'normal', color: '#666'}}>/Child</span>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="body mt-3">
                                                    <ul className="custom-ul" style={{listStyle: 'none', padding: 0}}>
                                                        <li style={{marginBottom: '10px'}}>
                                                            <i className="fa-solid fa-badge-check" style={{color: '#f7921f', marginRight: '10px'}}></i> 
                                                            Best Price Guaranteed
                                                        </li>
                                                        <li style={{marginBottom: '10px'}}>
                                                            <i className="fa-solid fa-badge-check" style={{color: '#f7921f', marginRight: '10px'}}></i> 
                                                            No Hidden Charges
                                                        </li>
                                                        <li style={{marginBottom: '10px'}}>
                                                            <i className="fa-solid fa-badge-check" style={{color: '#f7921f', marginRight: '10px'}}></i> 
                                                            Flexible Payment Options
                                                        </li>
                                                        <li style={{marginBottom: '10px'}}>
                                                            <i className="fa-solid fa-badge-check" style={{color: '#f7921f', marginRight: '10px'}}></i> 
                                                            Free Cancellation*
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="footer">
                                                    <button
                                                        className="vs-btn style9 w-100"
                                                        onClick={scrollToBooking}
                                                        style={{
                                                            background: '#f7921f',
                                                            color: 'white',
                                                            border: 'none',
                                                            padding: '12px 20px',
                                                            borderRadius: '5px',
                                                            fontSize: '16px',
                                                            fontWeight: '600',
                                                            cursor: 'pointer',
                                                            width: '100%',
                                                            transition: 'all 0.3s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.target.style.background = '#e6831a';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.target.style.background = '#f7921f';
                                                        }}
                                                    >
                                                        📅 Check Availability & Book
                                                    </button>
                                                    <p className="text-center mt-2">
                                                        Need help? <Link to="/contact" style={{color: '#f7921f'}}>Chat with us</Link>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="widget widget_quick_contact" style={{marginTop: '30px'}}>
                                    <h5 className="widget-title" style={{marginBottom: '20px'}}>📞 Quick Contact</h5>
                                    <div className="contact-info">
                                        <div className="contact-item" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '15px',
                                            padding: '10px',
                                            background: '#f8f9fa',
                                            borderRadius: '8px',
                                            marginBottom: '10px'
                                        }}>
                                            <i className="fa-solid fa-phone" style={{
                                                width: '40px',
                                                height: '40px',
                                                background: '#f7921f',
                                                color: 'white',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}></i>
                                            <div>
                                                <span style={{display: 'block', fontSize: '12px', color: '#666'}}>Call us 24/7:</span>
                                                <a href="tel:8317447895" style={{
                                                    color: '#f7921f',
                                                    textDecoration: 'none',
                                                    fontSize: '16px',
                                                    fontWeight: '500'
                                                }}>
                                                    83174 47895
                                                </a>
                                            </div>
                                        </div>
                                        <div className="contact-item" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '15px',
                                            padding: '10px',
                                            background: '#f8f9fa',
                                            borderRadius: '8px',
                                            marginBottom: '10px'
                                        }}>
                                            <i className="fa-brands fa-whatsapp" style={{
                                                width: '40px',
                                                height: '40px',
                                                background: '#25D366',
                                                color: 'white',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}></i>
                                            <div>
                                                <span style={{display: 'block', fontSize: '12px', color: '#666'}}>WhatsApp:</span>
                                                <a href="https://wa.me/918317447895" style={{
                                                    color: '#25D366',
                                                    textDecoration: 'none',
                                                    fontSize: '16px',
                                                    fontWeight: '500'
                                                }}>
                                                    83174 47895
                                                </a>
                                            </div>
                                        </div>
                                        <div className="contact-item" style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '15px',
                                            padding: '10px',
                                            background: '#f8f9fa',
                                            borderRadius: '8px'
                                        }}>
                                            <i className="fa-solid fa-envelope" style={{
                                                width: '40px',
                                                height: '40px',
                                                background: '#f7921f',
                                                color: 'white',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}></i>
                                            <div>
                                                <span style={{display: 'block', fontSize: '12px', color: '#666'}}>Email:</span>
                                                <a href="mailto:Booking@ascendtravelsolutions.in" style={{
                                                    color: '#f7921f',
                                                    textDecoration: 'none',
                                                    fontSize: '14px',
                                                    fontWeight: '500'
                                                }}>
                                                    Booking@ascendtravelsolutions.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="widget widget_why_choose" style={{marginTop: '30px'}}>
                                    <h5 className="widget-title" style={{marginBottom: '20px'}}>⭐ Why Choose This Tour?</h5>
                                    <ul className="custom-ul" style={{listStyle: 'none', padding: 0}}>
                                        <li style={{marginBottom: '10px', padding: '8px 0', borderBottom: '1px solid #eee'}}>
                                            <i className="fa-solid fa-check" style={{color: '#f7921f', marginRight: '10px'}}></i> 
                                            Perfect blend of culture & modernity
                                        </li>
                                        <li style={{marginBottom: '10px', padding: '8px 0', borderBottom: '1px solid #eee'}}>
                                            <i className="fa-solid fa-check" style={{color: '#f7921f', marginRight: '10px'}}></i> 
                                            Handpicked experiences
                                        </li>
                                        <li style={{marginBottom: '10px', padding: '8px 0', borderBottom: '1px solid #eee'}}>
                                            <i className="fa-solid fa-check" style={{color: '#f7921f', marginRight: '10px'}}></i> 
                                            Local expert guides
                                        </li>
                                        <li style={{marginBottom: '10px', padding: '8px 0', borderBottom: '1px solid #eee'}}>
                                            <i className="fa-solid fa-check" style={{color: '#f7921f', marginRight: '10px'}}></i> 
                                            Small group size
                                        </li>
                                        <li style={{marginBottom: '10px', padding: '8px 0'}}>
                                            <i className="fa-solid fa-check" style={{color: '#f7921f', marginRight: '10px'}}></i> 
                                            Best value for money
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Similar Tours Section */}
            <section className="vs-tour-package style-3 space-bottom bg-theme-07" style={{padding: '80px 0', background: '#f8f9fa'}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-auto mx-auto">
                            <div className="title-area text-center">
                                <span className="sec-subtitle text-capitalize" style={{color: '#f7921f'}}>
                                    You Might Also Like
                                </span>
                                <h2 className="sec-title" style={{fontSize: '36px', fontWeight: '700', marginTop: '10px'}}>
                                    Similar Travel Experiences
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        {similarTours.map((tour) => (
                            <div key={tour.id} className="col-md-6 col-xl-4">
                                <div className="tour-package-box style-3 bg-white-color" style={{
                                    background: 'white',
                                    borderRadius: '15px',
                                    overflow: 'hidden',
                                    boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                                    transition: 'transform 0.3s ease',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}>
                                    <div className="tour-package-thumb">
                                        <img
                                            src={tour.image}
                                            alt={tour.title}
                                            className="w-100"
                                            style={{ height: '250px', objectFit: 'cover' }}
                                        />
                                    </div>
                                    <div className="tour-package-content" style={{padding: '20px', flex: 1, display: 'flex', flexDirection: 'column'}}>
                                        <div className="location" style={{marginBottom: '10px'}}>
                                            <i className="fa-sharp fa-light fa-location-dot" style={{color: '#f7921f', marginRight: '5px'}}></i>
                                            <span style={{color: '#666'}}>{tour.location}</span>
                                        </div>
                                        <h5 className="title line-clamp-2" style={{
                                            marginBottom: '15px',
                                            minHeight: '50px',
                                            fontSize: '16px',
                                            fontWeight: '700',
                                            color: '#2c3e50'
                                        }}>
                                            <Link to={`/book/${tour.id}`} style={{color: '#333', textDecoration: 'none'}}>
                                                {tour.title}
                                            </Link>
                                        </h5>
                                        <div className="tour-package-footer" style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            borderTop: '1px solid #eee',
                                            paddingTop: '15px',
                                            marginBottom: '15px'
                                        }}>
                                            <div className="tour-duration">
                                                <i className="fa-regular fa-clock" style={{color: '#f7921f', marginRight: '5px'}}></i>
                                                <span>{tour.duration}</span>
                                            </div>
                                            <div className="pricing-info fw-medium">
                                                From
                                                <del className="text-theme-color fw-semibold" style={{margin: '0 5px', color: '#999'}}>
                                                    {tour.originalPrice}
                                                </del>
                                                <h5 className="new-price" style={{color: '#f7921f', display: 'inline', fontSize: '18px', fontWeight: '700'}}>
                                                    {tour.discountedPrice}
                                                </h5>
                                            </div>
                                        </div>
                                        <Link 
                                            to={`/book/${tour.id}`}
                                            style={{
                                                display: 'block',
                                                background: '#f7921f',
                                                color: 'white',
                                                textAlign: 'center',
                                                padding: '12px 20px',
                                                borderRadius: '8px',
                                                textDecoration: 'none',
                                                fontWeight: '600',
                                                marginTop: 'auto',
                                                transition: 'all 0.3s ease',
                                                border: '2px solid #f7921f'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.background = 'transparent';
                                                e.target.style.color = '#f7921f';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.background = '#f7921f';
                                                e.target.style.color = 'white';
                                            }}
                                        >
                                            View Details
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            </section>

            {/* <button
                className="scrollToTop scroll-btn"
                onClick={scrollToTop}
                style={{
                    position: 'fixed',
                    bottom: '30px',
                    right: '30px',
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#f7921f',
                    color: '#fff',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textDecoration: 'none',
                    fontSize: '20px',
                    transition: 'all 0.3s ease',
                    zIndex: 1000,
                    border: 'none',
                    cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#e6831a';
                    e.target.style.transform = 'translateY(-3px)';
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#f7921f';
                    e.target.style.transform = 'translateY(0)';
                }}
            >
                <i className="far fa-arrow-up"></i>
            </button> */}

            {/* CSS animations */}
            <style>{`
                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-20px); }
                    100% { transform: translateY(0px); }
                }
                
                .rating-badge {
                    margin-top: 10px;
                }

                .stars {
                    color: #ffd700;
                    margin-right: 5px;
                }

                .review-count {
                    color: #666;
                    font-size: 14px;
                }

                .image-badge {
                    position: absolute;
                    top: 15px;
                    left: 15px;
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                }

                .trending-badge,
                .family-badge {
                    background: rgba(255, 255, 255, 0.95);
                    padding: 5px 10px;
                    border-radius: 20px;
                    font-size: 12px;
                    font-weight: 600;
                    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                }

                .trending-badge {
                    background: linear-gradient(135deg, #ff6b6b, #ff8e53);
                    color: white;
                }

                .highlights-section {
                    background: #f8f9fa;
                    padding: 20px;
                    border-radius: 10px;
                    margin: 20px 0;
                }

                .highlights-section h5 {
                    color: #2c3e50;
                    margin-bottom: 15px;
                }

                .trip-info {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 15px;
                    margin-bottom: 30px;
                }

                .trip-info-box {
                    background: #f8f9fa;
                    padding: 15px;
                    border-radius: 8px;
                }

                .trip-info-box .header {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    margin-bottom: 10px;
                    color: #666;
                }

                .trip-info-box .header i {
                    color: #f7921f;
                }

                .trip-info-box .info-title {
                    margin: 0;
                    font-size: 14px;
                    line-height: 1.4;
                }

                .destination-single-meta {
                    background: #f7921f;
                    color: white;
                    padding: 15px;
                    border-radius: 8px;
                    text-align: center;
                    min-width: 80px;
                }

                .destination-single-meta h3 {
                    margin: 0;
                    font-size: 28px;
                    font-weight: 700;
                }

                .destination-single-meta span {
                    font-size: 14px;
                    opacity: 0.9;
                }

                .form-group {
                    margin-bottom: 20px;
                }

                .form-group label {
                    display: block;
                    margin-bottom: 5px;
                    font-weight: 500;
                    color: #333;
                }

                .form-group label span {
                    color: #f7921f;
                }

                .form-control {
                    width: 100%;
                    padding: 10px 15px;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                    font-size: 14px;
                    transition: all 0.3s ease;
                }

                .form-control:focus {
                    outline: none;
                    border-color: #f7921f;
                    box-shadow: 0 0 0 3px rgba(247, 146, 31, 0.1);
                }

                textarea.form-control {
                    resize: vertical;
                    min-height: 100px;
                }

                @media (max-width: 768px) {
                    .trip-info {
                        grid-template-columns: 1fr;
                    }
                    
                    .breadcrumb-title {
                        font-size: 32px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default BookDestination;